import { useEffect, useState } from "react";
import { apiClient } from "@/App";
import { toast } from "sonner";
import { errorText } from "@/lib/calendar";
import { ACTION_LABELS, fmtDate } from "./format";

export const ActivityPanel = () => {
  const [items, setItems] = useState(null);

  useEffect(() => {
    apiClient.get("/owner/activity").then((r) => setItems(r.data)).catch((e) => toast.error(errorText(e, "Could not load activity")));
  }, []);

  if (!items) return <p className="text-slate-500 py-12">Loading…</p>;

  return (
    <div data-testid="owner-activity-panel">
      <p className="text-sm text-slate-600 mb-4 max-w-2xl">Every Owner action, newest first. Reset links and codes are never stored here.</p>
      <ol className="relative border-l-2 border-slate-200 ml-2 space-y-5">
        {items.map((it) => (
          <li key={it.id} className="pl-6 relative" data-testid="owner-activity-item">
            <span className="absolute -left-[7px] top-1.5 w-3 h-3 rounded-full bg-lime-400 ring-4 ring-slate-50" />
            <p className="text-xs text-slate-500">{fmtDate(it.timestamp)}{it.ip ? ` · ${it.ip}` : ""}</p>
            <p className="font-semibold text-slate-900">{ACTION_LABELS[it.action] || it.action}</p>
            <p className="text-sm text-slate-600 break-words">{it.details}</p>
          </li>
        ))}
      </ol>
      {items.length === 0 && <p className="text-slate-400 py-10" data-testid="owner-activity-empty">No Owner actions yet.</p>}
    </div>
  );
};
